<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localGeoHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields : fieldsSummary"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
    div.py-2(class="a" ref="divA" id="report-fuel-tanker-info" style="font-size: 14px")
      .p-0(v-if="!reportData.IsSummary") Количество заправок: {{reportData.Data.Data.TotalCount}}
      .p-0(v-if="!reportData.IsSummary") Количество объектов: {{reportData.Data.Data.UniqueCount}}
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'FuelTankerFillings',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'Date',
        caption: 'Дата',
        fixed: true,
        width: 25,
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' })),
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'IButton',
      }, {
        dataField: 'DecimalKey',
        caption: 'Код IButton',
        width: 100,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' })),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' })),
        width: 120,
      }, {
        dataField: 'Duration',
        caption: 'Продолжительность',
        alignment: 'center',
      }, {
        dataField: 'Value',
        caption: 'Общее количество литров заправки',
        alignment: 'center',
      }],
      detailColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'Begin',
        name: 'Begin',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'End',
        name: 'End',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'Value',
        name: 'Value',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      fieldsSummary: [{
        dataField: 'ObjectName',
        caption: 'Объект',
      }, {
        dataField: 'Date',
        caption: 'Дата',
        fixed: true,
        width: 90,
        customizeText: params => (!params.value ? undefined : new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' })),
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 150,
      }, {
        dataField: 'Duration',
        caption: 'Продолжительность',
        alignment: 'center',
      }, {
        dataField: 'Value',
        caption: 'Общее количество литров заправки',
        alignment: 'center',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'Value',
        name: 'Value',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      index: 0,
      indexRow: 0,
    };
  },
  computed: {
    localGeoHeight () {
      return `calc(${this.localHeight} - ${this.reportData.IsSummary ? 16 : 58}px)`;
    },
  },
  watch: {
    reportData (value) {
      this.convertData(this.reportData);
      this.getSummary();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertData(this.reportData);
    this.getSummary();
  },
  methods: {
    convertData (data) {
      if (this.reportData.IsSummary) {
        let rows = [];
        data.Data.Data.forEach((_items, i) => {
          const items = _items;
          items.RowNum = i + 1;

          items.Group = i;
          items.Begin = null;
          items.End = null;
          items.Duration = items.SumDuration;
          items.Value = items.SumValue;
          items.Rows.forEach((_row, j) => {
            const item = _row;
            item.Group = i;
            item.RowNum = j + 1;
            item.Date = items.Date;
          });
          rows = rows.concat(items.Rows);
        });
        this.reportSummary = rows;
      } else {
        let rows = [];
        data.Data.Data.Rows.forEach((_group, i) => {
          const group = _group;
          group.Group = i;
          group.RowNum = i + 1;
          group.Begin = null;
          group.End = null;
          group.Duration = group.SumDuration;
          group.Value = group.SumValue;

          group.Rows.forEach((_item, j) => {
            const item = _item;
            item.Group = i;
            item.RowNum = `${i + 1}.${j + 1}`;
            item.Date = group.Date;
          });
          rows = rows.concat(group.Rows);
        });
        this.reportSummary = rows;
      }
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              if (!this.reportData.Data.Data.Rows[this.index]) {
                this.index = 0;
              }
              const value = options;
              if (options.groupIndex !== undefined) {
                const totalValue = this.reportData.Data.Data.Rows[this.index][options.name];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                if (options.name === 'Value') {
                  this.index += 1;
                }
              } else {
                const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
              }
            }
          },
          totalItems: this.detailColoumn.filter(x => x.column === 'RowNum' || x.column === 'Duration' || x.column === 'Value'),
          groupItems: this.detailColoumn.filter(x => x.column !== 'RowNum'),
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const data = this.reportData.Data.Data.filter(arr => arr.Rows.length > 0);
              if (!data[this.index]) {
                this.index = 0;
                this.indexRow = 0;
              }
              if (options.groupIndex === 0) {
                if (data[this.index] && !data[this.index].Rows[this.indexRow]) {
                  this.indexRow = 0;
                }
                value.totalValue = data[this.index] && data[this.index].Rows[this.indexRow] ? data[this.index].Rows[this.indexRow][`${options.name}`] : undefined;
                if (options.name === 'Value') {
                  this.indexRow += 1;
                  if (!data[this.index].Rows[this.indexRow]) {
                    this.index += 1;
                    this.indexRow = 0;
                  }
                }
              } else if (options.groupIndex === undefined) {
                const totalValue = this.reportData.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
              }
            }
          },
          totalItems: this.summaryColoumn.filter(x => x.column === 'RowNum' || x.column === 'Duration' || x.column === 'Value'),
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
